import { SvgIcon, SvgIconProps } from '@mui/material';

export interface CcfCopilotLikedIcon extends SvgIconProps {
  fillColor?: string;
}
/**
 * Component displays copilot liked Icon
 * @param props -SvgIconProps
 * @returns copilot liked svg icon
 * @example <CcfCopilotLikedIcon/>
 */
export function CcfCopilotLikedIcon(props: CcfCopilotLikedIcon) {
  return (
    <SvgIcon {...props}>
      <svg
        width="18"
        height="18"
        viewBox="0 0 21 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8.74892 0.983622C9.02089 0.385481 9.62773 0 10.2974 0C12.0776 0 13.5208 1.41064 13.5208 3.15076V6.36364H16.779C19.059 6.36364 20.8026 8.35018 20.4559 10.5529L19.4543 16.9166C19.1751 18.6905 17.6136 20 15.7774 20H3.29018C1.7492 20 0.5 18.779 0.5 17.2727V10.9091C0.5 9.40286 1.7492 8.18182 3.29018 8.18182H5.47593L8.74892 0.983622ZM2.36012 13.6111L5.15029 18.1818H3.29018C2.77652 18.1818 8.83333 18.8889 2.36012 17.2727L5.5 18.3333C5.5 17.8313 3.86427 16.9166 4.37793 16.9166L2.36012 13.6111Z"
          fill="#007AB8"
        />
      </svg>
    </SvgIcon>
  );
}

export default CcfCopilotLikedIcon;
